import React from 'react'
import { WrapDiv, WrapSpan } from './styles'

type Props =
  | {
      horizontal: string
      vertical?: string
    }
  | {
      horizontal?: string
      vertical: string
    }

function Spacer({ horizontal, vertical, ...restProps }: Props) {
  return vertical ? (
    <WrapDiv {...restProps} vertical={vertical} />
  ) : (
    <WrapSpan {...restProps} horizontal={horizontal} />
  )
}

export default Spacer
